// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"Footer_footerBox__2a-Dq","footerText":"Footer_footerText__2akxZ","footerText2":"Footer_footerText2__1-wgP","link":"Footer_link__1rb3P","img":"Footer_img__1V6_A"};